var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24.0001C48 10.7452 37.2548 5.34058e-05 24 5.34058e-05C10.7452 5.34058e-05 0 10.7452 0 24.0001C0 35.9791 8.77645 45.908 20.25 47.7085V30.9376H14.1563V24.0001H20.25V18.7126C20.25 12.6976 23.833 9.37505 29.3152 9.37505C31.941 9.37505 34.6875 9.8438 34.6875 9.8438V15.7501H31.6612C28.6798 15.7501 27.75 17.6001 27.75 19.498V24.0001H34.4062L33.3422 30.9376H27.75V47.7085C39.2235 45.908 48 35.9791 48 24.0001Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3422 30.9375L34.4063 24H27.75V19.498C27.75 17.6 28.6798 15.75 31.6612 15.75H34.6875V9.84375C34.6875 9.84375 31.941 9.375 29.3152 9.375C23.833 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7084C21.4719 47.9002 22.7243 48 24 48C25.2758 48 26.5281 47.9002 27.75 47.7084V30.9375H33.3422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e31ed161de3edfb021f7c10f63963def.svg";
export { ForwardRef as ReactComponent };